import { cn } from "./classNames-DcGnTh2N.js";
import { useArgoDesign } from "./context-U293r3v-.js";
import { Root } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
//#region src/components/Card/styles.ts
const cardClassnames = cva([
	"tw:flex",
	"tw:flex-col",
	"tw:rounded-[var(--radius-card,var(--radius-lg,0.5rem))]",
	"tw:bg-card",
	"tw:text-card-foreground",
	"tw:interactive:cursor-pointer",
	"tw:interactive:no-underline",
	"tw:interactive:hover:no-underline",
	"tw:interactive:hover:text-card-foreground",
	"tw:interactive:focus:text-card-foreground",
	"tw:interactive:motion-safe:transition-[translate,box-shadow,border-color]",
	"tw:interactive:hover:border-input",
	"tw:interactive:hover:shadow-md",
	"tw:interactive:motion-safe:hover:-translate-y-0.5",
	"tw:interactive:active:translate-y-0",
	"tw:interactive:focus-visible:outline",
	"tw:interactive:focus-visible:outline-1",
	"tw:interactive:focus-visible:-outline-offset-1",
	"tw:interactive:focus-visible:outline-ring",
	"tw:interactive:focus-visible:ring-4",
	"tw:interactive:focus-visible:ring-ring/30"
], {
	defaultVariants: { padding: "small" },
	variants: {
		bordered: {
			true: "tw:border tw:border-solid tw:border-border",
			false: "tw:shadow-raised tw:data-[argo=true]:shadow-sm"
		},
		padding: {
			none: "tw:p-0",
			small: "tw:gap-4 tw:px-6 tw:py-4",
			medium: "tw:gap-4 tw:p-7",
			large: "tw:gap-4 tw:p-8"
		}
	}
});
const cardHeaderClassnames = cva("tw:flex", {
	defaultVariants: {
		divider: false,
		layout: "row"
	},
	variants: {
		divider: {
			true: "tw:min-h-16 tw:border-b tw:border-border tw:px-6 tw:py-2",
			false: ""
		},
		layout: {
			row: "tw:items-center tw:justify-between tw:gap-4",
			inline: "tw:items-center tw:gap-3",
			stack: "tw:flex-col tw:gap-1.5"
		}
	}
});
const cardContentClassnames = cva("", {
	defaultVariants: { padded: false },
	variants: { padded: {
		true: "tw:px-6 tw:py-5",
		false: ""
	} }
});
const cardTitleClassnames = cn("tw:m-0", "tw:leading-6", "tw:font-medium", "tw:text-base", "tw:text-card-foreground");
const cardDescriptionClassnames = cn("tw:m-0", "tw:text-sm", "tw:text-muted-foreground");
//#endregion
//#region src/components/Card/CardContent.tsx
const CardContent = ({ children, className, padded = false, ...rest }) => /* @__PURE__ */ jsx("div", {
	...rest,
	className: cardContentClassnames({
		className,
		padded
	}) || void 0,
	children
});
//#endregion
//#region src/components/Card/CardDescription.tsx
/** Muted secondary line under `Card.Title`; pair with `Card.Header layout="stack"`. */
const CardDescription = ({ children, className, ...rest }) => /* @__PURE__ */ jsx("p", {
	className: cn(cardDescriptionClassnames, className),
	...rest,
	children
});
//#endregion
//#region src/components/Card/CardHeader.tsx
const CardHeader = ({ children, className, divider = false, layout = "row", ...rest }) => {
	const renderArgo = useArgoDesign();
	return /* @__PURE__ */ jsx("div", {
		...rest,
		"data-argo": renderArgo,
		className: cardHeaderClassnames({
			className,
			divider,
			layout
		}),
		children
	});
};
//#endregion
//#region src/components/Card/CardTitle.tsx
const CardTitle = ({ children, className, as: Tag = "h3", ...rest }) => /* @__PURE__ */ jsx(Tag, {
	className: cn(cardTitleClassnames, className),
	...rest,
	children
});
//#endregion
//#region src/components/Card/Card.tsx
const Card = ({ children, className, bordered = false, padding = "small", asChild = false, interactive, ...rest }) => {
	const renderArgo = useArgoDesign();
	return /* @__PURE__ */ jsx(asChild ? Root : "div", {
		...rest,
		"data-argo": renderArgo,
		"data-interactive": interactive,
		className: cardClassnames({
			className,
			bordered,
			padding
		}),
		children
	});
};
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Title = CardTitle;
Card.Description = CardDescription;
//#endregion
export { Card };

//# sourceMappingURL=Card-Bpc_ZlL4.js.map